<template>
  <div>
    <v-container>
      <img v-if="isLoading" class="loading-icon" src="../assets/loading-icon.gif" alt="Loading...">
      <div class="logo">
        <img src="../assets/logo2.png" alt="Mostar Rock School Logo">
      </div>
      <div class="login-form">
        <h1 class="header-text">
          <span>Prijava
            <div class="header-text-line"></div>
          </span>
        </h1>
        <v-form>
          <span class="error-message" v-if="isLoginFailed">Uneseni podaci nisu ispravni.</span>
          <v-flex xs12>
            <v-text-field v-model="user.Username" label="Korisničko ime"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-text-field v-model="user.Password" @keyup.enter="login" type="password" label="Lozinka"></v-text-field>
          </v-flex>
          <v-flex xs12>
            <v-checkbox :label="'Zapamti me'" v-model="user.RememberMe"></v-checkbox>
          </v-flex>
          <v-flex xs12>
            <v-btn class="main-btn v-btn theme--light login-btn" @click="login">
              <!-- <img src="../assets/loading-icon.gif" alt="" class="loading-icon-login"> -->
              <span>Prijava</span>
            </v-btn>
          </v-flex>
        </v-form>
      </div>
      <div class="login-ilustration">
        <img src="../assets/undraw_compose_music_ovo2.svg" alt="Login ilustration">
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: {
        Username: "",
        Password: ""
      },
      isLoginFailed: false,
      isLoading: false,
    };
  },
  methods: {
    login() {
      this.isLoading = true;
      this.isLoginFailed = false;
      this.$store.state.services.authService
        .login(this.user)
        .then(result => {
          localStorage.setItem("user-token", result.data.token);
          this.getUserData(result.data);
          this.isLoginFailed = false;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoginFailed = true;
          this.isLoading = false;
        });
    },
    getUserData(token) {
      this.$store.state.services.authService
        .getData(token)
        .then(result => {
          localStorage.setItem("user-roles", result.data.UserRoles);
          localStorage.setItem("user", result.data.UserId);
          localStorage.setItem("user-name", result.data.UserName);
          localStorage.setItem("user-profile", result.data.UserProfile);
          this.$store.dispatch("setShowNotification", result.data.ShowNotification && result.data.UserRoles.includes("Profesor"));
          if (
            result.data.UserRoles.length === 1
            && result.data.UserRoles.includes("Polaznik")
            && !result.data.HasPaidSubscription
          ) {
            this.$store.dispatch("setShowUnpaidSubscriptionNotification", true);
            localStorage.setItem("unpaid-subscription", "unpaid");
          }
          this.$router.push("/Home/Appointments");
        })
        .catch(err => {});
    }
  },
  created(){
    let userToken = localStorage.getItem("user-token");
    if(userToken){
      this.getUserData(userToken);
    }
  }
};
</script>

<style scoped>
.logo {
  text-align: center;
  padding: 40px 0;
}
.logo img {
  width: 21%;
}
h1{
  margin-bottom: 40px;
}
.error-message{
  color: #bb0000;
  margin-bottom: 10px;
}
.login-form {
  width: 50%;
  float: left;
}
.login-ilustration {
  width: 50%;
  float: left;
  text-align: center;
}
.login-ilustration img {
  width: 80%;
}
.loading-icon-login{
  width: 20px;
}
@media (max-width: 980px){
  .logo img{
    width: 30%;
  }
  .login-form{
    width: 100%;
    padding: 0 30px;
  }
  .login-btn{
    width: 100%;
  }
  .login-ilustration{
    display: none;
  }
}
</style>
